export default {
  envStr: 'dev',
  appName: '方舟物联网平台',
  apiHost: '/fenydata-java-gateway',
  docUrl: 'http' + '://192.168.1.111:30080/doc',
}
